// extracted by mini-css-extract-plugin
module.exports = {"price":"price_price__2rzLo pt-1 pb-1","price_num":"price_price_num__3h9Nt pr-1 text text_type_digits-default"};